/**
 * Where to brief officially — a link the pilot follows, never a fetch.
 *
 * Those sites are AIS and met services with their own terms; a flight plan that
 * re-published their pages would be neither legal nor trustworthy. So this is
 * one quiet line with the service's own name on it, and the app has never asked
 * it anything.
 *
 * One line for the whole pane, de-duplicated by service, rather than one under
 * every card: three aerodromes in one country share one briefing service, and
 * the same link printed three times reads as clutter and is skipped as clutter.
 * A flight that crosses a border names both, which is exactly when it matters.
 */
import { Fragment } from 'react';

import { useT } from '../../i18n';
import { briefingFor, type BriefingLink } from '../../wx';

export function BriefingLinks({ icaos }: { icaos: readonly string[] }) {
  const t = useT();
  const services = new Map<string, BriefingLink>();
  for (const id of icaos) {
    const b = briefingFor(id);
    if (b && !services.has(b.url)) services.set(b.url, b);
  }
  if (services.size === 0) return null;
  return (
    <p className="wx-brief">
      {t('wx.nometar.brief')}{' '}
      {[...services.values()].map((b, i) => (
        <Fragment key={b.url}>
          {i > 0 ? ' · ' : ''}
          <a href={b.url} target="_blank" rel="noreferrer noopener">
            {b.service}
          </a>
        </Fragment>
      ))}
    </p>
  );
}
